import defaultReducer from './defaultReducer';

const defaultState = {
    open: false,
    header: "",
    comments: []
}


export default defaultReducer('BANKING_COMMENTS_MODAL', defaultState)
